import React from 'react';
import { PersonAvatar } from '@teo/components';
export function SimpleCorrectionHeader({
  course,
  lesson,
  lessonStatus,
  student,
  correction,
  submittedAt,
}: any) {
  /*
  console.log("student", student)
  console.log("course", course)
  console.log("lesson", lesson)
  console.log("lessonStatus", lessonStatus)
  console.log("correction", correction)
  */

  const formattedDate = new Date(correction?.submitDate).toLocaleDateString(
    'en-GB',
    {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }
  );

  return (
    <div className="border-grey-300 flex items-center justify-between border-b bg-white px-6 py-4 text-sm font-medium">
      <div className="flex items-center gap-4">
        <PersonAvatar
          id={student?.id}
          name={
            student?.username ||
            `${student?.firstName || ''} ${student?.lastName || ''}`
          }
          imageSrc={student?.picture || undefined}
        />
        <span>
          {student?.username || `${student?.firstName} ${student?.lastName}`}
        </span>
      </div>

      <div className="truncate text-center text-base font-semibold">
        {lesson?.name}
      </div>

      <div className="text-right text-sm text-gray-500">
        Submitted: {formattedDate}
      </div>
    </div>
  );
}
